export default "__VITE_ASSET__KMQsxz2z__"